function arrayPush(array, values) {
  for (var index = -1, length = values.length, offset = array.length; ++index < length; )
    array[offset + index] = values[index];
  return array;
}
export {
  arrayPush as default
};
//# sourceMappingURL=_arrayPush.js.map
